import { SketchPicker } from "react-color";
import styled from "styled-components";
const SIZES = {
    PICKER_WIDTH: 230
};
export default {
    SketchPicker: styled(SketchPicker) `
    padding: ${({ theme }) => theme["padding-xxs"]} !important;
    width: ${SIZES.PICKER_WIDTH}px !important;
    border-radius: unset !important;
    box-shadow: none !important;
    #rc-editable-input-1 {
      width: calc(100% - ${({ theme }) => theme["padding-xxs"]}) !important;
    }
    input:not(#rc-editable-input-1) {
      width: 100% !important;
    }
    input {
      border: 1px solid ${({ theme }) => theme["input-border"]} !important;
      box-shadow: ${({ theme }) => theme["input-shadow"]} !important;
      font-family: ${({ theme }) => theme["font-family-base"]} !important;
      font-size: ${({ theme }) => theme["font-size-small"]} !important;
      border-radius: ${({ theme }) => theme["border-radius-small"]} !important;
      padding: 4px 10px !important;
      outline: none;
      &:focus,
      &:focus-visible {
        border-color: ${({ theme }) => theme["input-border-focus"]} !important;
      }
    }
    label {
      ${({ theme }) => theme["font-size-small"]} !important;
    }
    .saturation-black + div > div {
      width: 8px !important;
      height: 8px !important;
      transform: translate(-4px, -4px) !important;
      box-shadow:
        rgb(255, 255, 255) 0px 0px 0px 4px,
        rgba(0, 0, 0, 0.2) 0px 0px 1px 1px inset,
        rgba(0, 0, 0, 0.5) 0px 0px 9px 1px !important;
      cursor: pointer;
    }
    > :first-child + .flexbox-fix {
      height: 30px !important;
      > * {
        height: 14px !important;
        padding: 8px 0;
        &:last-child {
          margin-left: 8px !important;
        }
        > * {
          height: 14px !important;
          overflow: visible !important;
        }
        .hue-horizontal > div > div {
          margin-top: -1px !important;
          transform: translateX(-5px) !important;
          width: 10px !important;
          height: 16px !important;
          border-radius: ${({ theme }) => theme["border-radius-base"]} !important;
          cursor: pointer;
          box-shadow: rgba(0, 0, 0, 0.7) 0px 0px 3px !important;
        }
      }
    }
  `
};
